import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigsService } from '../pzCore/config.service';

@Component({
    selector: 'pz-submit-button',
    template: `
        <nz-form-item nzType="flex" nzJustify="center">
            <nz-form-control>
                <button nz-button nzType="primary" [disabled]="!formValid">{{ submit }}</button>
                <button nz-button (click)="emmitReset($event)" style="margin-left: 10px;">{{ reset }}</button>
            </nz-form-control>
        </nz-form-item>
    `,
})

export class SubmitComponent implements OnInit {
    public submit = 'Submit';
    public reset = 'Reset';
    @Input() public formValid: boolean;
    @Output() public resetForm: EventEmitter<void> = new EventEmitter();
    public constructor(protected config: ConfigsService) {
    }

    public ngOnInit() {
        this.submit = this.config.exportComponent().submitButton;
        this.reset = this.config.exportComponent().resetButton;
    }

    public emmitReset(e) {
        e.preventDefault();
        this.resetForm.emit();
    }
}
